import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import { FaCamera } from "react-icons/fa";
import dp from "../../assets/empty.jpg";
import InputField from "../../component/InputField";
import { LinearProgress } from "@mui/material";
import AlertBox from "../../component/AlertBox";
import ButtonCompo from "../../component/ButtonCompo";

function CompanySettings() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeData !== null &&
      employeeData?.admin?.companyManagement === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  const [companyData, setCompanyData] = useState({});
  const profileImageRef = useRef(null);
  const [selectedProfileImage, setSelectedProfileImage] = useState(undefined);
  const [profileImageUrl, setProfileImageUrl] = useState(undefined);
  const letterHeadRef = useRef(null);
  const [selectedLetterHead, setSelectedLetterHead] = useState(undefined);
  const [letterHeadUrl, setLetterHeadUrl] = useState(undefined);
  const [profileImage, setProfileImage] = useState(undefined);
  const [letterHead, setLetterHead] = useState(undefined);
  const [reload, setReload] = useState(false)

  // fields
  const [companyName, setCompanyName] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyWeb, setCompanyWeb] = useState("");
  const [gstNo, setGstNo] = useState("")
  const [cinNo, setCinNo] = useState("")
  const [certNo, setCertNo] = useState("")

  // address fields
  const [plotNo, setPlotNo] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");

  async function getCompanyData() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/company/data`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setCompanyData(res.data?.data);
      setCompanyEmail(res.data?.data?.companyEmail);
      setCompanyName(res.data?.data?.companyName);
      setCompanyPhone(res.data?.data?.companyPhone);
      setCompanyWeb(res.data?.data?.website);
      setGstNo(res.data?.data?.gstNo)
      setCinNo(res.data?.data?.cinNo)
      setCertNo(res.data?.data?.certificateNo)
      setSelectedProfileImage(res.data?.data?.logoUrl)
      setSelectedLetterHead(res.data?.data?.letterHeadUrl)
      // address
      setPlotNo(res.data?.data?.plotNo);
      setStreetAddress(res.data?.data?.streetAddress);
      setPincode(res.data?.data?.pincode);
      setState(res.data?.data?.state);
      setCountry(res.data?.data?.country);
      // files
      setProfileImage(res.data?.data?.logoUrl || undefined);
      setLetterHead(res.data?.data?.letterHeadUrl);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Data fetch failed");
    } finally {
      setLoading(false);
    }
  }

  //edit generate date
  async function editCompanyData() {
    let formData = new FormData()
    formData.append("logo", profileImage)
    formData.append("letterhead", letterHead)
    formData.append("companyName", companyName || "")
    formData.append("gstNo", gstNo || "")
    formData.append("cinNo", cinNo || "")
    formData.append("companyEmail", companyEmail || "")
    formData.append("companyPhone", companyPhone || "")
    formData.append("website", companyWeb || "")
    formData.append("plotNo", plotNo || "")
    formData.append("streetAddress", streetAddress || "")
    formData.append("pincode", pincode || "")
    formData.append("state", state || "")
    formData.append("country", country || "")
    formData.append("certificateNo", certNo)
    console.log(formData)
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/update/company`,
        method: "put",
        withCredentials: true,
        data: formData
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Date updated successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Date update failed");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getCompanyData();
  }, []);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Company Settings
          </h1>
          <div>
            <div className="w-full flex justify-center items-center">
              <section className="w-[8rem] h-[8rem] relative">
                <input
                  type="file"
                  className="hidden"
                  onChange={(e) => {
                    setProfileImage(e?.target?.files[0]);
                    setProfileImageUrl(
                      URL.createObjectURL(e?.target?.files[0])
                    );
                  }}
                  ref={profileImageRef}
                />
                <img
                  src={profileImageUrl !== undefined ? profileImageUrl : selectedProfileImage?.length > 0 ? `${SERVER_URL}/api/v1/file/view/${selectedProfileImage}` : dp}
                  className="w-full h-full object-contain"
                  alt=""
                />
                <section className="bg-sky-500 absolute bottom-3 left-[80%] p-2 rounded-full">
                  <FaCamera
                    className="text-[20px] text-white cursor-pointer"
                    onClick={() => profileImageRef.current.click()}
                  />
                </section>
              </section>
            </div>
            <div className="mt-5 space-y-5">
              <div>
                <h2 className="text-[18px] font-medium">Basic Informations</h2>
                <div className="grid grid-cols-3 gap-5 mt-3">
                  <InputField
                    label="Company Name"
                    onChange={(eve) => setCompanyName(eve?.target?.value)}
                    value={companyName}
                  />
                  <InputField
                    label="Company Email"
                    onChange={(eve) => setCompanyEmail(eve?.target?.value)}
                    value={companyEmail}
                  />
                  <InputField
                    label="Company Phone"
                    onChange={(eve) => setCompanyPhone(eve?.target?.value)}
                    value={companyPhone}
                  />
                  <InputField
                    label="Company Website"
                    onChange={(eve) => setCompanyWeb(eve?.target?.value)}
                    value={companyWeb}
                  />
                  <InputField
                    label="Company GST No"
                    onChange={(eve) => setGstNo(eve?.target?.value)}
                    value={gstNo}
                  />
                  <InputField
                    label="Company CIN No"
                    onChange={(eve) => setCinNo(eve?.target?.value)}
                    value={cinNo}
                  />
                  <InputField
                    label="Company Certificate No"
                    onChange={(eve) => setCertNo(eve?.target?.value)}
                    value={certNo}
                  />
                </div>
              </div>
              <div>
                <h2 className="text-[18px] font-medium">Address</h2>
                <div className="grid grid-cols-3 gap-5 mt-3">
                  <InputField
                    label="Plot No"
                    onChange={(eve) => setPlotNo(eve?.target?.value)}
                    value={plotNo}
                  />
                  <InputField
                    label="Street Address"
                    onChange={(eve) => setStreetAddress(eve?.target?.value)}
                    value={streetAddress}
                  />
                  <InputField
                    label="Pincode"
                    onChange={(eve) => setPincode(eve?.target?.value)}
                    value={pincode}
                  />
                  <InputField
                    label="State"
                    onChange={(eve) => setState(eve?.target?.value)}
                    value={state}
                  />
                  <InputField
                    label="Country"
                    onChange={(eve) => setCountry(eve?.target?.value)}
                    value={country}
                  />
                </div>
              </div>
              <div>
                <h2 className="text-[18px] font-medium">Upload Letter Head</h2>
                <section className="w-[10rem] h-[10rem] relative mt-5">
                  <input
                    type="file"
                    className="hidden"
                    onChange={(e) => {
                      setLetterHead(e?.target?.files[0]);
                      setLetterHeadUrl(
                        URL.createObjectURL(e?.target?.files[0])
                      );
                    }}
                    ref={letterHeadRef}
                  />
                  <img
                    src={letterHeadUrl !== undefined ? letterHeadUrl : selectedLetterHead?.length > 0 ? `${SERVER_URL}/api/v1/file/view/${selectedLetterHead}` : dp}
                    className="w-full h-full object-contain"
                    alt=""
                  />
                  <section className="bg-sky-500 absolute bottom-3 left-[80%] p-2 rounded-full">
                    <FaCamera
                      className="text-[20px] text-white cursor-pointer"
                      onClick={() => letterHeadRef.current.click()}
                    />
                  </section>
                </section>
              </div>
            </div>
            <div className="mt-5 flex justify-end">
              <ButtonCompo variant={"contained"} onClick={editCompanyData}>Save Changes</ButtonCompo>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompanySettings;
